import { render } from "./DueChip.vue?vue&type=template&id=76355b62&scoped=true"
import script from "./DueChip.vue?vue&type=script&lang=js"
export * from "./DueChip.vue?vue&type=script&lang=js"

import "./DueChip.vue?vue&type=style&index=0&id=76355b62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76355b62"

export default script